export const WelcomeMessage = () => <span className='flex flex-col items-center text-large-title font-normal dt:items-start'>
  <span className='text-black-999'>Welcome to </span><span className='text-label-g-300'>Investor Portal</span>
</span>;
